import { useUserSpiralId } from '@store'

import { useSpiralById } from './useSpiralById'

export const useUserSpiral = () => {
  const spiralId = useUserSpiralId()
  const { spiral } = useSpiralById({ spiralId: spiralId || '' })

  return { spiral }
}
